import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __spreadValues } from "./armor-system-JQVN7XCJ.js";

// src/hooks/usePopper.ts
import { useMemo, useState } from "react";
import { usePopper as useReactPopper } from "react-popper";
var DEFAULT_OFFSET = [0, 10];
var usePopper = function usePopper(panelRef, triggerRef, props) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    arrowRef = _useState2[0],
    setArrowRef = _useState2[1];
  var _ref = props || {},
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? DEFAULT_OFFSET : _ref$offset,
    allowedAutoPlacements = _ref.allowedAutoPlacements,
    _ref$arrowPadding = _ref.arrowPadding,
    arrowPadding = _ref$arrowPadding === void 0 ? 0 : _ref$arrowPadding,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? "bottom" : _ref$align;
  var options = useMemo(function () {
    var result = {
      modifiers: [{
        name: "arrow",
        options: {
          element: arrowRef,
          padding: arrowPadding
        }
      }, {
        name: "offset",
        options: {
          offset: offset
        }
      }],
      placement: align
    };
    if (allowedAutoPlacements) {
      result.modifiers.push({
        name: "flip",
        options: {
          allowedAutoPlacements: allowedAutoPlacements
        }
      });
    }
    return result;
  }, [arrowRef, arrowPadding, offset, align, allowedAutoPlacements]);
  var _useReactPopper = useReactPopper(triggerRef.current, panelRef.current, options),
    styles = _useReactPopper.styles,
    attributes = _useReactPopper.attributes;
  return {
    panelProps: __spreadValues({
      style: styles.popper
    }, attributes.popper),
    arrowProps: {
      ref: setArrowRef,
      // todo: tighten
      style: styles.arrow
    }
  };
};
export { usePopper };